var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvancement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.146 18.33a1.338 1.338 0 01-1.186-.67l-1.898-3.286-4.353 7.539c3.279 0 6.569-.042 9.841-.042h10.777L15.193 8.364l-4.887 9.252a1.343 1.343 0 01-1.16.715zm-.026-1.34l5.332-10.093a.838.838 0 011.481 0l7.969 15.086a.837.837 0 01-.74 1.228c-3.957 0-7.928.042-11.877.042H.84a.838.838 0 01-.726-1.256l5.224-9.047a.836.836 0 011.45 0l2.333 4.04z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.436 4.656a.34.34 0 01.339-.335h.74a.33.33 0 01.33.335l-.033 2.68a.34.34 0 01-.34.336h-.739a.329.329 0 01-.33-.335l.033-2.68z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.177 5.176c.33.13.686-.114.686-.468V1.25a.502.502 0 00-.686-.468L10.772 2.51a.503.503 0 000 .936l4.405 1.729zm-1.93-2.197l1.276.5v-1l-1.275.5z",
    fill: "currentColor"
  })));
}
export default SvgAdvancement;